import css from 'styled-jsx/css';

export default css`
  .discussions {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    padding-left: 20px;
    background: linear-gradient(#242424, #141414);
    flex-grow: 1;
  }
  .dicussions-content-wrapper {
    width: 100%;
    position: sticky;
    top: 80px;
    padding-top: 50px;
  }
  .discussions-title {
    position: sticky;
    display: block;
    padding: 15px 15px 15px 0;
    margin: 0;
    font-family: 'Roboto-Medium';
    font-size: 36px;
    font-weight: 600;
  }
  .discussions-wrapper {
    position: sticky;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 10px;

    padding: 0 15px;
    border-left: 2px solid #ffffff;
    z-index: 0;
  }
  .discussions-wrapper div {
    display: flex;
    flex-direction: column;
  }

  .sub-titles-wrapper {
    position: relative;
    margin: 10px 0 0 30px;
    padding-left: 10px;
  }

  .sub-titles-wrapper::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: #a41c1c;
  }

  .sub-titles-wrapper span:first-child::before {
    content: '';
    position: absolute;
    left: 0;
    top: -1px;
    width: 5px;
    height: 1px;
    background-color: #a41c1c;
  }

  .sub-titles-wrapper span:last-child::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -1px;
    width: 5px;
    height: 1px;
    background-color: #a41c1c;
  }

  .discussion {
    width: 100%;
    cursor: pointer;
    padding: 10px 15px;
    border-radius: 5px 0 0 5px;
    transition: color 0.1s ease-in;
    font-family: 'Roboto-Medium';
    font-size: 16px;
    font-weight: 600;
  }
  .discussion:hover {
    color: #a41c1c;
  }
  .active {
    background-color: #a41c1c;
    margin-left: 20px;
    margin-right: -20px;
    transition: all 0.5s ease-in;
  }
  .active:hover {
    color: white;
  }
  @media (max-width: 800px) {
    .discussions {
      display: none;
    }
  }
`;
